export default __webpack_public_path__ + "static/media/auth-img.15ae8428.svg";